import { Component } from '@angular/core';

@Component({
  selector: 'app-bi-speed-limit',
  templateUrl: './bi-speed-limit.component.html', // Usa el HTML externo
  styleUrls: ['./bi-speed-limit.component.css']  // Usa el CSS externo
})
export class BiSpeedLimitComponent {
   // JSON de respuesta
}
